export const setParams = (params) => {
    const url = new URL(location?.href);
    Object.entries(params).forEach(([key, value]) => {
        url.searchParams.set(key, value);
    });
    history?.pushState({}, "", url);
};
//# sourceMappingURL=setParams.js.map